import { render } from "./FormField.vue?vue&type=template&id=c2341dda"
import script from "./FormField.vue?vue&type=script&lang=ts"
export * from "./FormField.vue?vue&type=script&lang=ts"
script.render = render

export default script